"use client";

import dynamic from "next/dynamic";
import Link from "next/link";

// The original hero starfield — neural particle network, drifting deep-space
// stars, and the wandering UFO (click it) — retired from the homepage when
// the live solar system took over, preserved here at full screen.
const ParticleField = dynamic(() => import("./ParticleField"), {
  ssr: false,
  loading: () => null,
});

const StarfieldExperience = () => {
  return (
    <main className="relative h-screen overflow-hidden bg-[#070710]">
      <ParticleField />

      {/* Same atmosphere kit as the hero — keeps /starfield feeling like
          a room in the same building, not a separate site. */}
      <div className="hero-scanlines pointer-events-none absolute inset-0 z-20" />
      <div className="hero-vignette pointer-events-none absolute inset-0 z-10" />

      {/* HUD frame — quiet telemetry voice, content stays out of the way
          of the field itself. */}
      <div className="pointer-events-none absolute inset-0 z-30 flex flex-col justify-between p-6">
        <div className="flex items-start justify-between text-[10px] text-white/40 font-[family-name:var(--font-jetbrains-mono)] tracking-widest uppercase">
          <div className="hero-anim-1">
            <p className="text-emerald-300/70">mdg::deep_field</p>
            <p className="mt-1 text-white/30">retired hero · preserved intact</p>
          </div>
          <Link
            href="/"
            className="pointer-events-auto rounded-md border border-white/10 bg-white/5 px-4 py-2 text-white/60 backdrop-blur-sm transition-all hover:border-white/30 hover:text-white"
          >
            ← ./home
          </Link>
        </div>

        <div className="hero-anim-3 flex justify-center pb-2 text-center">
          <p className="text-[10px] text-white/30 font-[family-name:var(--font-jetbrains-mono)] tracking-[0.25em] uppercase">
            unidentified craft detected — it responds to a click
          </p>
        </div>
      </div>
    </main>
  );
};

export default StarfieldExperience;
